import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Loads /api/home/sections — trending, new_arrivals, best_sellers in one call. */
export function useHomeSections(limit = 12) {
  const [data, setData] = useState({ trending: [], new_arrivals: [], best_sellers: [] });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    api.get(`/home/sections?limit=${limit}`)
      .then((r) => { if (!cancelled) setData(r.data || { trending: [], new_arrivals: [], best_sellers: [] }); })
      .catch(() => { if (!cancelled) setData({ trending: [], new_arrivals: [], best_sellers: [] }); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [limit]);
  return { ...data, loading };
}
